import React, { useEffect, useState } from "react";
import { Button, Card, Form, Modal } from "react-bootstrap";
import Heading from "Components/Heading";
import Footer from "Components/Footer";
import SampleDataTable from "Components/DataTables";
import HolidayAPIs from "../../APIs/holidays";
import { toast } from "react-toastify";
import { Formik } from "formik";
import * as Yup from "yup";
import { FaRegEdit, FaRegTrashAlt } from "react-icons/fa";

const Holidays = () => {
  const [holidays, setHolidays] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [modalMode, setModalMode] = useState("add"); // 'add' or 'edit'
  const [currentEditItem, setCurrentEditItem] = useState(null);

  const handleShowAdd = () => {
    setModalMode("add");
    setCurrentEditItem(null);
    setShowModal(true);
  };

  const handleShowEdit = (item) => {
    setModalMode("edit");
    setCurrentEditItem(item);
    setShowModal(true);
  };

  const handleClose = () => setShowModal(false);

  const validationSchema = Yup.object().shape({
    date: Yup.string()
      .required("Holiday date is required")
      .matches(/^\d{4}-\d{2}-\d{2}$/, "Date must be in YYYY-MM-DD format"),
  });

  const getAllHolidays = async () => {
    try {
      const res = await HolidayAPIs.getHolidays();
      if (res) {
        //console.log("res is", res)
        // Same response wrapper as backend: res.data.data
        setHolidays(res.data.data);
      }
    } catch (e) {
      toast.error("Failed to load holidays.");
    }
  };

  const submitHandler = async (data, resetForm) => {
    setIsLoading(true);
    try {
      const res = await HolidayAPIs.createHoliday(data); // { date: "YYYY-MM-DD" }
      if (res) {
        toast.success("Holiday Added Successfully.");
        resetForm({ values: "" });
        setShowModal(false);
        getAllHolidays();
      }
    } catch (error) {
      toast.error("Failed to add Holiday.");
    }
    setIsLoading(false);
  };

  const editHoliday = async (data, resetForm) => {
    setIsLoading(true);
    try {
      // console.log("currentid:", currentEditItem.id, data)
      await HolidayAPIs.updateHolidayById(currentEditItem.id, data);
      toast.success("Holiday Updated Successfully.");
      setShowModal(false);
      getAllHolidays();
    } catch (error) {
      toast.error("Failed to update Holiday.");
    }
    setIsLoading(false);
  };

  const deleteHoliday = async (id) => {
    setIsLoading(true);
    try {
      // console.log("date is :", date)
      await HolidayAPIs.deleteHolidayById(id);
      toast.success("Holiday Deleted Successfully.");
      getAllHolidays();
    } catch (error) {
      toast.error("Failed to delete Holiday.");
    }
    setIsLoading(false);
  };

  useEffect(() => {
    getAllHolidays();
  }, []);

  return (
    <>
      <section>
        <Heading text={"Holidays"} />
        <Card>
          <Button
            variant="primary"
            onClick={handleShowAdd}
            size="sm"
            style={{ width: "150px", marginBottom: "20px" }}
            disabled={isLoading}
          >
            Add Holiday
          </Button>

          {/* Popup Add-Edit */}
          <Modal show={showModal} onHide={handleClose}>
            <Modal.Header closeButton>
              <Modal.Title>
                {modalMode === "add" ? "Add Holiday" : "Edit Holiday"}
              </Modal.Title>
            </Modal.Header>

            <Modal.Body>
              <Formik
                onSubmit={(values, { resetForm }) => {
                  if (modalMode === "add") {
                    submitHandler(values, resetForm);
                  } else {
                    editHoliday(values, resetForm);
                  }
                }}
                initialValues={{
                  date:
                    modalMode === "edit" && currentEditItem
                      ? currentEditItem.date
                      : "",
                }}
                validationSchema={validationSchema}
                validateOnChange={false}
              >
                {({ handleSubmit, handleChange, values, errors }) => (
                  <Form onSubmit={handleSubmit}>
                    <Form.Group className="mb-3">
                      <Form.Label>Holiday Date</Form.Label>
                      <Form.Control
                        type="text"
                        name="date"
                        placeholder="YYYY-MM-DD"
                        onChange={handleChange}
                        value={values.date}
                        isInvalid={!!errors.date}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.date}
                      </Form.Control.Feedback>
                    </Form.Group>

                    <Button variant="primary" type="submit" disabled={isLoading}>
                      Save Changes
                    </Button>
                  </Form>
                )}
              </Formik>
            </Modal.Body>
          </Modal>

          {/* Listing Table */}
          <SampleDataTable
            columns={[
              { accessor: "date", Header: "Holiday Date" },
              {
                // accessor: "date",
                id: "actions", // ✅ unique id
                Header: "Action",
                Cell: ({ row }) => (
                  <>
                    <Button
                      className="me-3"
                      onClick={() => handleShowEdit(row.original)}
                      disabled={isLoading}
                    >
                      <FaRegEdit />
                    </Button>

                    <Button
                      variant="danger"
                      className="me-3"
                      disabled={isLoading}
                      onClick={async () => {
                        const isConfirmed = window.confirm(
                          "Are you sure you want to delete this Holiday?"
                        );
                        if (isConfirmed) {
                          await deleteHoliday(row.original.id);
                        }
                      }}
                    >
                      <FaRegTrashAlt />
                    </Button>
                  </>
                ),
              },
            ]}
            data={holidays}
          />

          <Footer />
        </Card>
      </section>
    </>
  );
};

export default Holidays;